module.exports = __webpack_public_path__ + "img/home_service.69d9bd8e.png";